module.exports = __webpack_public_path__ + "static/media/chip-15500.e523bea1.png";